(function () {
  document.addEventListener('click', function (event) {
    var addToCartBtn = event.target.closest('product-form.card__add-to-cart button[name="add"]');
    if (!addToCartBtn || addToCartBtn.getAttribute('aria-disabled') === 'true') return;

    var card = addToCartBtn.closest('.card-wrapper');
    if (!card || card.dataset.hasSizeOption !== 'true') return;

    var quickViewBtn = card.querySelector('.quick-add button[data-modal-id]');
    if (!quickViewBtn) return;

    // Open the product without a variant param so size stays unselected
    var baseUrl = quickViewBtn.getAttribute('data-product-url').split('?')[0];
    quickViewBtn.setAttribute('data-product-url', baseUrl);

    var selectedSwatch = card.querySelector('.js-color-swatches input:checked');
    var colorValue = selectedSwatch ? selectedSwatch.value : null;

    event.preventDefault();
    event.stopPropagation();
    quickViewBtn.click();

    if (!colorValue) return;

    // Once the modal loads, carry over the color picked on the card
    var tries = 0;
    var timer = setInterval(function () {
      tries++;
      var modal = document.getElementById(quickViewBtn.dataset.modalId);
      var inputs = modal ? modal.querySelectorAll('variant-radios input') : [];
      if (inputs.length || tries > 40) {
        clearInterval(timer);
        var colorInput = Array.prototype.find.call(inputs, function (i) {
          return i.name.indexOf('Color') === 0 && i.value === colorValue;
        });
        if (colorInput && !colorInput.checked) {
          colorInput.checked = true;
          colorInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    }, 150);
  }, true);
})();